<!--
 * @Description : 
 * @Author      : pishengjun
 * @Date        : 2024-12-19 11:41:45
-->
<template>
  <template v-if="isMobile">
    <MobileHome></MobileHome>
  </template>
  <a-style-provider v-else hash-priority="high" :transformers="[legacyLogicalPropertiesTransformer]">
    <a-config-provider
      :locale="zhCN"
      :theme="{
        token: {
          borderRadius: 4,
        },
      }"
    >
      <messageContext />
      <notificationContext />
      <template v-if="isUpgraded">
        <UpgradePage></UpgradePage>
      </template>
      <template v-if="isReady">
        <router-view></router-view>
      </template>
    </a-config-provider>
  </a-style-provider>
</template>
<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { message, notification, legacyLogicalPropertiesTransformer } from "ant-design-vue";
import { BasicServiceClass } from "./http/api/basicService";
import { store } from "./store";
import UpgradePage from "./views/upgrade.vue";
import { isMobile, deviceDetect } from "mobile-device-detect";
import MobileHome from "./views/mobileHome.vue";

// message.useMessage 创建支持读取 context 的 contextHolder (通过顶层注册的方式代替 message 静态方法，因为静态方法无法消费上下文，因而 ConfigProvider 的数据也不会生效。)
const [messageApi, messageContext] = message.useMessage();
const [notificationApi, notificationContext] = notification.useNotification();

export default defineComponent({
  components: { messageContext, notificationContext, UpgradePage, MobileHome },
  setup() {
    onMounted(async () => {
      try {
        await event.getSettings();
        state.isReady = true;
        state.isUpgraded = false;
      } catch (error) {
      } finally {
        if (!!store.state.upgradeData) {
          state.isUpgraded = true;
        }
      }
    });

    // console.log("isMobile", isMobile, deviceDetect());

    const state = reactive({
      isReady: false,
      isUpgraded: false,
    });

    const event = {
      // 获取系统设置和访问设置, 合并设置
      async getSettings() {
        await BasicServiceClass.getSystemSetting();
      },
    };
    return {
      ...toRefs(state),
      ...event,
      zhCN,
      legacyLogicalPropertiesTransformer,
      isMobile,
    };
  },
});
</script>
<style lang="less"></style>
